import { put } from 'redux-saga/effects';

import { store } from '../store';
import { send } from '../../helpers/requests';
import * as actions from './actions';
import * as UserSettingsActions from '../UserSettings/actions';
import { selectToken } from '../selectors';

export function* deleteAccountRequestSaga(payload) {
  try {
    yield send({
      url: `/accounts/${payload.data.id}`,
      method: 'DELETE',
      data: payload.data.data,
      token: selectToken(store.getState()),
    });
    yield put(actions.deleteAccountRequestSuccess({ id: payload.data.id }));
  } catch (error) {
    yield put(actions.deleteAccountRequestFailure(error));
  }
}

export function* getAccountsRequestSaga() {
  try {
    const res = yield send({
      url: `/accounts`,
      method: 'GET',
      token: selectToken(store.getState()),
    });
    yield put(actions.getAccountsRequestSuccess(res));
  } catch (error) {
    yield put(actions.getAccountsRequestFailure(error));
  }
}

export function* updateAccountRequestSaga(payload) {
  try {
    const res = yield send({
      url: `/accounts/${payload.data.id}`,
      method: 'PUT',
      data: payload.data.data,
      token: selectToken(store.getState()),
    });
    yield put(actions.updateAccountRequestSuccess(res));
    yield put(actions.getAccountsRequest());
    if (payload.data.id === 'tracker') yield put(UserSettingsActions.getUserSettingsRequest());
  } catch (error) {
    yield put(actions.updateAccountRequestFailure(error));
  }
}

export function* updateCalendarRequestSaga(payload) {
  try {
    const res = yield send({
      url: `/calendar/calendars/${payload.data.id}`,
      method: 'PUT',
      data: payload.data.data,
      token: selectToken(store.getState()),
    });
    yield put(actions.updateCalendarRequestSuccess({ res, id: payload.data.id, data: payload.data.data }));
    payload.data.cb && payload.data.cb();
  } catch (error) {
    yield put(actions.updateCalendarRequestFailure(error));
  }
}
